"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var texts_1 = __importDefault(require("../../../common/src/constrains/locale/texts"));
var value_checker_1 = __importDefault(require("../../../common/src/utils/validation/value_checker"));
var date_parser_1 = __importDefault(require("../../../common/src/utils/date/date_parser"));
var SalesForceAutoComplete = /** @class */ (function () {
    function SalesForceAutoComplete() {
    }
    /**
     *
     * @param period
     * @param capacity
     */
    SalesForceAutoComplete.calcKobetu = function (period, capacity) {
        var periodSystem = SalesForceAutoComplete.getSystemValue(period, 'period');
        var capacitySystem = SalesForceAutoComplete.getSystemValue(capacity, 'apply_capacity');
        if (!periodSystem || !capacitySystem) {
            return '';
        }
        return SalesForceAutoComplete.KOBETU_TANKA_MAP[periodSystem + "_" + capacitySystem];
    };
    /**
     *
     * @param period
     */
    SalesForceAutoComplete.calcOralCare = function (period) {
        var periodSystem = SalesForceAutoComplete.getSystemValue(period, 'period');
        if (!periodSystem) {
            return '';
        }
        return SalesForceAutoComplete.ORAL_TANKA_MAP["" + periodSystem];
    };
    /**
     *
     * @param inputNumber
     */
    SalesForceAutoComplete.calcInputAgency = function (inputNumber) {
        if (!inputNumber) {
            return '';
        }
        inputNumber = Number(inputNumber);
        if (Number.isNaN(inputNumber)) {
            return '';
        }
        return String(inputNumber * SalesForceAutoComplete.INPUT_TANKA);
    };
    SalesForceAutoComplete.getSystemValue = function (dbValue, i18nKey) {
        var result = '';
        texts_1.default.ja.view.contract_form.update.data_labels.apply_info[i18nKey].some(function (data) {
            if (data.value === dbValue) {
                result = data.system_value;
                // Break;
                return true;
            }
        });
        return result;
    };
    /**
     *
     * @param contraqctDataStr
     */
    SalesForceAutoComplete.isKeiyakutyu = function (contraqctDataStr) {
        var contractStartDate = Date.parse(contraqctDataStr);
        if (isNaN(contractStartDate)) {
            return false;
        }
        return new Date().getTime() > contractStartDate;
    };
    /**
     *
     * @param contraqctDataStr
     */
    SalesForceAutoComplete.getRequestStartDate = function (contraqctDataStr) {
        var contractStartDate = Date.parse(contraqctDataStr);
        if (isNaN(contractStartDate)) {
            return '';
        }
        var date = new Date(contractStartDate);
        return date_parser_1.default.toString(new Date(date.getFullYear(), date.getMonth() + 1));
    };
    /**
     *
     * @param contraqctDataStr
     * @param period
     */
    SalesForceAutoComplete.getContractEdate = function (contraqctDataStr, period) {
        var contractStartDate = Date.parse(contraqctDataStr);
        if (isNaN(contractStartDate)) {
            return '';
        }
        var periodSystem = SalesForceAutoComplete.getSystemValue(period, 'period');
        if (!periodSystem) {
            return '';
        }
        if (periodSystem === 'month') {
            return '';
        }
        var date = new Date(contractStartDate);
        return date_parser_1.default.toString(new Date(date.getFullYear(), date.getMonth() + SalesForceAutoComplete.PERIOD_MAP[periodSystem], 0));
    };
    SalesForceAutoComplete.getEdateStrFromItPeriod = function (contraqctDataStr, years) {
        if (value_checker_1.default.isBlank(years) || value_checker_1.default.isBlank(contraqctDataStr)) {
            return '';
        }
        var yearNumber = Number(years.replace('年', ''));
        if (isNaN(yearNumber)) {
            return '';
        }
        var edateTime = Date.parse(contraqctDataStr);
        if (isNaN(edateTime)) {
            return '';
        }
        var edate = new Date(edateTime);
        return date_parser_1.default.toString(new Date(edate.getFullYear() + yearNumber, edate.getMonth(), 0));
    };
    SalesForceAutoComplete.getRiyoNensu = function (period) {
        var periodSystem = SalesForceAutoComplete.getSystemValue(period, 'period');
        if (periodSystem === 'year') {
            return '1年';
        }
        return '';
    };
    Object.defineProperty(SalesForceAutoComplete, "INPUT_TANKA", {
        /**
         * @returns {number}
         */
        get: function () {
            return 1000;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SalesForceAutoComplete, "KOBETU_TANKA_MAP", {
        /**
         *
         */
        get: function () {
            return {
                'month_one': '14800',
                'month_eleven': '29800',
                'month_twenty_one': '42800',
                'month_thirty_six': '54800',
                'six_one': '88800',
                'six_eleven': '178800',
                'six_twenty_one': '256800',
                'six_thirty_six': '328800',
                'year_one': '158000',
                'year_eleven': '318000',
                'year_twenty_one': '458000',
                'year_thirty_six': '598000'
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SalesForceAutoComplete, "PERIOD_MAP", {
        get: function () {
            return {
                'month': 1,
                'six': 6,
                'year': 12
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SalesForceAutoComplete, "ORAL_TANKA_MAP", {
        get: function () {
            return {
                'month': '9800',
                'six': '58800',
                'year': '108000'
            };
        },
        enumerable: true,
        configurable: true
    });
    return SalesForceAutoComplete;
}());
exports.default = SalesForceAutoComplete;



//////////////////
// WEBPACK FOOTER
// ./src/utils/sales_force/sales_force_auto_complete.ts
// module id = R5kA
// module chunks = 1